import { render, staticRenderFns } from "./HierarquiaCard.vue?vue&type=template&id=e5fc31a8&scoped=true"
import script from "./HierarquiaCard.vue?vue&type=script&lang=js"
export * from "./HierarquiaCard.vue?vue&type=script&lang=js"
import style0 from "./HierarquiaCard.vue?vue&type=style&index=0&id=e5fc31a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fc31a8",
  null
  
)

export default component.exports